'use strict';

import { isElement, forEach } from 'lodash';
import Tooltip from 'tooltip.js';
import mustache from 'mustache';

import containerManager from '../../01-helpers/filter-context/container-manager';
import { subscribe } from '../../01-helpers/event-manager';

import { addClass } from '../../01-helpers/utilities/class';
import { formatCurrencyWithSymbol } from '../../01-helpers/utilities/currency';
import { get as getPageOptions } from '../../01-helpers/utilities/options';

import { SEARCH_CLICKED } from '../../02-const/event-names';

import { fillItem, pushDataLayer } from '../../05-domain/enhanced-ecommerce/items';

const moduleName = 'filter-results',
	selectors = {
		base: `.js-${moduleName}`,
		container: `.js-${moduleName}-container`,
		courseResultTemplate: '#courseDetailTemplate',
		nonbookableResultTemplate: '#nonbookableDetailTemplate',
		tooltip: `.js-${moduleName}-tooltip`
	},
	translationsKey = {
		key: 'translations',
		NonBookableCourses: 'NonBookableCourses',
		NonBookableCoursesNearby: 'NonBookableCoursesNearby',
		LoadingCourses: 'LoadingCourses',
		NoCoursesFound: 'NoCoursesFound'
	};

/**
 *
 * @param {any} template
 * @param {any} course
 */
function renderTemplate(template, course) {
	mustache.tags = ['[[', ']]'];
	const parsed = mustache.render(template, course);

	return parsed;
}

/**
 *
 **/
function showContainer() {
	addClass(this.baseElement, 'show');
}

function renderHeader(title) {
	return `<div class="c-result__title">${title}</div>`;
}



/**
 *
 */
function bindEvents() {
	subscribe(SEARCH_CLICKED, showContainer.bind(this));

	this.filterContext.onBeforeUpdate(() => {
		const resultContainer = this.baseElement.querySelector(selectors.container);

		$(resultContainer).html(
			`<span class="c-loader"></span> ${this.translations[translationsKey.LoadingCourses]}`
		);
	});

	this.filterContext.onUpdate(({ currentState }) => {
		// check if there is a response from webservice
		if (currentState.response) {
			const response = currentState.response,
				courses = response.Courses,
				nearbyCourses = response.NearbyCourses,
				nonBookableCourses = response.NonBookableCourses,
				nonBookableNearbyCourses = response.NonBookableNearbyCourses,
				resultContainer = this.baseElement.querySelector(selectors.container),
				$resultContainer = $(resultContainer),
				resultTemplate = this.baseElement.querySelector(
					selectors.courseResultTemplate
				).innerHTML,
				nonBookableTemplate = this.baseElement.querySelector(
					selectors.nonbookableResultTemplate
				).innerHTML,
				items = [],
				brand = 'Golfgo',
				list = {
					name: 'filter list',
					id: 'Fl1'
                };
			let item_count = 0;

			resultContainer.innerHTML = '';

			// set template for courses
			if (courses) {
				const $courseList = $('<ul></ul>');
				$resultContainer.append($courseList);
				// loop through response
				forEach(courses, (course) => {
					// fill the mustache template with data
					course.Fee = course.Fee ? formatCurrencyWithSymbol(course.Fee) : '';
					$courseList.append(renderTemplate(resultTemplate, course));
					items.push(fillItem(brand, course, list, item_count++));
				});

				
			}

			// set template for nearby courses
			if (nearbyCourses) {
				const $nearbyList = $('<ul></ul>');
				$resultContainer.append(renderHeader('Beschikbare golfclubs- en banen'));
				$resultContainer.append($nearbyList);
				// loop through response
				forEach(nearbyCourses, (course) => {
					// fill the mustache template with data
					course.Fee = course.Fee ? formatCurrencyWithSymbol(course.Fee) : '';
					$nearbyList.append(renderTemplate(resultTemplate, course));
					items.push(fillItem(brand, course, list, item_count++));
				});

			}

			if (!courses && !nearbyCourses) {
				const message = `
					<div class="c-result__message">${this.translations[translationsKey.NoCoursesFound]}</div>
				`;

				$resultContainer.append(message);
			}

			// Non bookable courses
			if (nonBookableCourses) {
				const $nonBookableList = $('<ul></ul>');
				$resultContainer.append(renderHeader(this.translations[translationsKey.NonBookableCourses]));

				$resultContainer.append($nonBookableList);
				// loop through response
				forEach(nonBookableCourses, (course) => {
					// fill the mustache template with data
					$nonBookableList.append(renderTemplate(nonBookableTemplate, course));
					items.push(fillItem(brand, course, list, item_count++));
				});
			}

			// Non bookable courses nearby
			if (nonBookableNearbyCourses) {
				const $nonBookableListNearbyList = $('<ul></ul>');
				$resultContainer.append(
					renderHeader(this.translations[translationsKey.NonBookableCoursesNearby])
				);

				// loop through response
				forEach(nonBookableNearbyCourses, (course) => {
					// fill the mustache template with data
					$nonBookableListNearbyList.append(renderTemplate(nonBookableTemplate, course));
					items.push(fillItem(brand, course, list, item_count++));
				});

				$resultContainer.append($nonBookableListNearbyList);
			}

			if (nonBookableCourses || nonBookableNearbyCourses) {
				$(selectors.tooltip).each(function () {
					const el = this,
						instance = new Tooltip(el, {
							html: true,
							title: `<a class="c-result__tooltip" href="tel:${el.getAttribute(
								'data-tt-title'
							)}"><i class="im im-phone"></i>${el.getAttribute('data-tt-title')}</a>`,
							trigger: 'hover'
						});
				});
			}

			pushDataLayer('view_item_list', items);
		}
	});
}

/* ========================================================================== */

export class FilterResults {
	constructor(baseElement) {
		this._configure(baseElement);
		this._setup();
	}

	_configure(baseElement) {
		if (!isElement(baseElement)) {
			return false;
		}

		this.baseElement = baseElement;
		this.filterContext = containerManager.getContainer();
	}

	_setup() {
		bindEvents.call(this);

		this.translations = getPageOptions(translationsKey.key);

	}
}

/* ========================================================================== */

const initFilterResults = () => {
	forEach(document.querySelectorAll(selectors.base), (resultsElement) => {
		new FilterResults(resultsElement);
	});
};

initFilterResults();
